import React, { useRef, useEffect, useState } from "react";
import { ConvoMessage } from "./ConvoMessage";
import { IChat } from "types/IChat";
import { ICurrentUser } from "types/ICurrentUser";
import UnreadMsg from "components/Unread/UnreadMsg";
import { IMessage } from "types/IMessage";
import { viewFor } from "utils/constants";
import { useSelector } from "react-redux";
import formatTime from "utils/formatTime";
import { useLocation } from "react-router-dom";
import ChatLoader from "components/ChatLoader";

// import { ws } from "stores/middlewares/socket";

interface IChatsContext {
  messages: IChat;
  chatId: string;
  currentUser: ICurrentUser;
  onImageClick: (messageId: any) => void;
  markMessageAsRead: (messageId: any) => void;
  submitNewMessage: (msg: any) => void;
  setUnseenMsgCount: (count: any) => void;
  unseenMsgCount: number;
  scrolledDown: boolean;
  setScrolledDown: (any: any) => void;
  setIsFeedbackSession: (value: boolean) => void;
  botName: string;
}

const Convo = ({
  messages: allMessages,
  chatId,
  currentUser,
  onImageClick,
  markMessageAsRead,
  submitNewMessage,
  setUnseenMsgCount,
  unseenMsgCount,
  scrolledDown,
  setScrolledDown,
  setIsFeedbackSession,
  botName
}: IChatsContext) => {
  // console.log("allMessages", allMessages);

  let dates = Object.keys(allMessages);
  dates = dates.reverse();
  let first = "TODAY";
  dates.sort(function (x, y) {
    return x === first ? 1 : y === first ? -1 : 0;
  });

  // console.log("dates", dates);

  let messageIdToScroll: any = useRef(null);
  const [msgSentToBot, setMsgSentToBot] = useState("");
  const typingData = useSelector((state: any) => {
    return state.typingReducer;
  });
  const [msgTyping, setMsgTyping] = useState<string>("");
  const [isChatClosed, setIsChatClosed] = useState(false);
  const { pathname } = useLocation();
  const chatInfo = useSelector((state: any) => {
    return state?.chatInfoReducer;
  });

  useEffect(() => {
    setMsgTyping(typingData.message);
  }, [typingData]);

  useEffect(() => {
    const { hasUnseenMessage, unseenMessageId } = getUnseenMessage(allMessages);
    if (hasUnseenMessage) {
      messageIdToScroll.current = unseenMessageId;
      setScrolledDown(false);
    }
  }, [allMessages]);

  const getUnseenMessage = (allMessages: IChat) => {
    let flattenedMessages: IMessage[] = [];
    for (let key of Object.keys(allMessages)) {
      flattenedMessages = [...flattenedMessages, ...allMessages[key]];
    }
    flattenedMessages = flattenedMessages.filter(function (message) {
      return viewFor !== String(message.senderType) && message.type !== "info";
    });
    let unseenMessageIndex = flattenedMessages.length - 1;
    for (let i = 0; i < flattenedMessages?.length; i++) {
      if (flattenedMessages[i].isReadByReceiver === true) {
        unseenMessageIndex = i - 1;
        break;
      }
    }
    if (isChatClosed) {
      setUnseenMsgCount(0);
    } else if (
      unseenMessageIndex >= 0 &&
      !scrolledDown &&
      unseenMessageIndex + 1 !== unseenMsgCount
    ) {
      setUnseenMsgCount(unseenMessageIndex + 1);
    }
    return {
      hasUnseenMessage: unseenMessageIndex === -1 ? false : true,
      unseenMessageId:
        unseenMessageIndex >= 0
          ? flattenedMessages[unseenMessageIndex]?.messageId
          : undefined,
      count: unseenMessageIndex + 1
    };
  };

  const allChats: any = JSON.parse(JSON.stringify(allMessages));
  const isMakeoUser =
    botName === "makeo_buddy" && pathname?.startsWith("/user");

  if (dates.length === 0 && isMakeoUser) {
    return <ChatLoader />;
  }
  return (
    <>
      {dates.length === 0 ? (
        <p className="no-conversation-found">No conversation found</p>
      ) : (
        dates.map((date, dateIndex) => {
          if (msgTyping?.length && dateIndex === dates.length - 1) {
            allChats[date].unshift({
              buttonJson: "[]",
              content: `<div class="flex-center">
                          <div class="typing-text">Typing</div>
                          <div class="messageTypingIndicator flex-center">
                          <div class="dot"></div>
                          <div class="dot"></div>
                          <div class="dot"></div>
                        </div>
                        </div>`,
              deliveryStatus: [],
              isReadByReceiver: false,
              messageId: "",
              msgSource: "",
              readBy: [],
              sender:
                typingData?.user === "user"
                  ? currentUser.id
                  : chatInfo?.currentAgent?.agentId,
              senderType: currentUser.type === "user" ? "agent" : "user",
              timeStamp: "",
              timeString: "",
              type: "text"
            });
          }
          let messages: any = allChats[date];
          messages = messages.slice().reverse();
          if (dateIndex === 0) {
            const lastMsg = messages[messages.length - 1];
            if (
              lastMsg.senderType === "BOT" &&
              msgSentToBot !== "" &&
              msgSentToBot !== lastMsg.messageId
            ) {
              setMsgSentToBot("");
            }
          }

          return (
            <div key={dateIndex} className="chat__content-holder">
              <div className="chat__date-wrapper">
                <span className="chat__date"> {date.toLowerCase()}</span>
              </div>
              <div className="chat__msg-group">
                {messages.map((message: any, msgIndex: number) => {
                  const { hasUnseenMessage, unseenMessageId, count } =
                    getUnseenMessage(allMessages);
                  const isCurrentUserSender =
                    viewFor === String(message.senderType);

                  const clubMessage = isMakeoUser && message?.isFirstMsg;

                  if (message.type === "feedback_v2") {
                    setIsFeedbackSession(true);
                    !isChatClosed && setIsChatClosed(true); //change set only when is false
                  } else if (setIsFeedbackSession) {
                    setIsFeedbackSession(false);
                  }

                  return (
                    <>
                      {hasUnseenMessage &&
                      message.type !== "feedback_v2" &&
                      message?.messageId === unseenMessageId ? (
                        <UnreadMsg count={count} />
                      ) : null}
                      <ConvoMessage
                        message={message}
                        isCurrentUserSender={isCurrentUserSender}
                        onImageClick={onImageClick}
                        markMessageAsRead={markMessageAsRead}
                        currentUserName={currentUser.name}
                        key={message.messageId}
                        submitNewMessage={submitNewMessage}
                        currentUserNameType={currentUser.type}
                        currentUserNameId={currentUser.id}
                        isLastMessage={msgIndex === messages.length - 1}
                        setMsgSentToBot={setMsgSentToBot}
                        msgSentToBot={msgSentToBot}
                        clubMessage={clubMessage}
                        chatId={chatId}
                        setIsFeedbackSession={setIsFeedbackSession}
                      />
                    </>
                  );
                })}
                {msgSentToBot.length > 0 &&
                allMessages[dates[0]][0].senderType !== "BOT" ? (
                  <ConvoMessage
                    message={{ type: "typing" }}
                    isCurrentUserSender={false}
                    onImageClick={onImageClick}
                    markMessageAsRead={markMessageAsRead}
                    currentUserName={currentUser.name}
                    submitNewMessage={submitNewMessage}
                    currentUserNameType={currentUser.type}
                    currentUserNameId={currentUser.id}
                    isLastMessage={true}
                    setMsgSentToBot={setMsgSentToBot}
                    msgSentToBot={msgSentToBot}
                    chatId={chatId}
                    setIsFeedbackSession={setIsFeedbackSession}
                  />
                ) : null}
              </div>
            </div>
          );
        })
      )}
    </>
  );
};

export default Convo;
